import React from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from 'react-highcharts';
import Highcharts from 'highcharts';

const GroupedBarChart = ({ data, xAxisCategories, seriesNames, colors, isFontSizeBig }) => {
  const series = seriesNames.map((name, index) => ({
    name,
    data: data[index],
    color: colors[index]
  }));

  const config = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      backgroundColor: 'rgba(0, 0, 0, 0)',
      animation: {
        duration: 1000,
      },
      type: 'column'
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: xAxisCategories,
      crosshair: true,
      type: 'datetime',
      labels: {
        formatter: function () {
          return Highcharts.dateFormat('%b %Y', this.value);
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: null,
      },
    },
    tooltip: {
      formatter: function () {
        let s = `<span style="font-weight: bold; ${isFontSizeBig ? 'font-size:16px' : 'font-size:12px'}">${Highcharts.dateFormat('%b %Y', this.x)}</span>
                 <table class="table table-condensed" style="${isFontSizeBig ? 'font-size:16px' : 'font-size:12px'}; margin-top:1em; margin-bottom: 0;">`;
        this.points.forEach(function (point) {
          s += `<tr>
                    <td style="color:${point.series.color};">${point.series.name}:&nbsp;</td>
                    <td class="text-right" style="color:${point.series.color};"><b>${point.y}</b></td>
                  </tr>`;
        });
        return s + '</table>';
      },
      headerFormat: `<span style="font-weight: bold; ${isFontSizeBig ? 'font-size:16px' : 'font-size:12px'}">{point.key}</span>
        <table class="table table-condensed" style="${isFontSizeBig ? 'font-size:16px' : 'font-size:12px'}; margin-top:1em; margin-bottom: 0;">`,
      pointFormat: `<tr>
        <td style="color:{series.color};">{series.name}:&nbsp;</td>
        <td class="text-right"><b>{point.formatedY}</b></td>
      </tr>`,
      footerFormat: '</table>',
      shared: true,
      useHTML: true,
      backgroundColor: 'rgba(0,0,0, 0.75)',
      borderColor: 'rgba(0,0,0, 0.95)',
      style: {
        color: 'rgba(255, 255, 255, 0.75)',
      },
    },
    legend: {
      itemStyle: {
        fontSize: isFontSizeBig ? '16px' : null,
      },
    },
    yAxis: [
      {
        title: {
          text: null,
        },
        tickAmount: 9,
        labels: {
          style: {
            fontSize: isFontSizeBig ? '16px' : null,
          },
        },
        alternateGridColor: 'rgba(66,66,66,0.05)',
        lineWidth: 0,
        plotLines: [{
          value: 0,
          dashStyle: 'dashed',
          color: 'rgba(0, 0, 0, 0.5)',
          width: 2,
          label: {
            text: null,
          },
        }],
      }
    ],
    plotOptions: {
      series: {
        marker: {
          fillColor: '#ffffff',
          lineWidth: 2,
          radius: 5,
          lineColor: null,
        },
      },
    },
    series,
  };

  return <ReactHighcharts config={config} />;
};

GroupedBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  xAxisCategories: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
  seriesNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  isFontSizeBig: PropTypes.arrayOf(PropTypes.bool),
  colors: PropTypes.arrayOf(PropTypes.string),
};

export default GroupedBarChart;
